"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MailIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 12.4a1.6 1.6 0 01-1.6 1.6H1.6A1.6 1.6 0 010 12.4V5.368a.16.16 0 01.258-.126l6.758 5.27a1.6 1.6 0 001.968 0l6.758-5.27a.16.16 0 01.258.126V12.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 3.28C0 2.573.573 2 1.28 2h13.44c.707 0 1.28.573 1.28 1.28v.157a.64.64 0 01-.26.515L8.953 8.976a1.6 1.6 0 01-1.904 0L.26 3.952A.64.64 0 010 3.437V3.28z"
  })))
});
MailIcon.displayName = 'MailIcon';
var _default = exports.default = MailIcon;